module.exports = __webpack_public_path__ + "static/img/serverNew2.a21226f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serve/serverNew2.jpg
// module id = tCxR
// module chunks = 0